<template>
  <div>
    <h1>{{ headerText }}</h1>
    <v-row justify="center" align="center" class="mt-5 appointmentsRoot">
      <v-col cols="12" sm="8" md="8">
        <v-list two-line>
          <template v-for="(day, index) in bookingOptions">
            <v-list-item :key="index + 'label'" ripple>
              <v-list-item-content class="text-left">
                <v-list-item-title v-if="day.date">{{
                  day.date
                }}</v-list-item-title>
                <v-list-item-subtitle
                  >{{ day.slots.length }} appointments
                  scheduled</v-list-item-subtitle
                >
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                  color="primary black--text"
                  :to="{
                    name: 'appointmentDetails',
                    params: { calEventId: day.date },
                  }"
                  >View Appointments</v-btn
                >
              </v-list-item-action>
            </v-list-item>
            <v-divider v-if="index + 1 < users.length" :key="index"></v-divider>
          </template>
        </v-list>
      </v-col>
      <!-- Easy way for us to add admin users  -->
      <!-- <input type="text" v-model="adminEmail" />
      <button @click="addAdmin">add man</button>
      <span>{{ message }}</span> -->
    </v-row>
    <v-btn @click="showAllDays = !showAllDays">{{ bookingBtnText }}</v-btn>
  </div>
</template>
<script>
import moment from "moment";
import { db, functions } from "../firebase/firebase";
import UtilsMixin from "../mixins/UtilsMixin";

export default {
  name: "Appointments",
  mixins: [UtilsMixin],
  data: () => ({
    newWorkout: "",
    adminEmail: "",
    message: "",
    bookedDays: [],
    showAllDays: true,
  }),
  computed: {
    bookingBtnText() {
      return this.showAllDays ? "Show Last 30 Days" : "Show All Bookings";
    },
    bookingOptions() {
      return this.showAllDays ? this.bookedDays : this.bookingsFromLast30Days;
    },
    headerText() {
      return this.showAllDays ? "All Bookings" : "Bookings in Last 30 Days";
    },
    bookingsFromLast30Days() {
      const today = moment.now();
      return this.bookedDays.filter((day) => {
        const thirtyDaysAgo = moment().subtract(30, "days");
        const date = moment(day.date);
        if (date.isBetween(thirtyDaysAgo, today)) {
          return day;
        }
      });
    },
  },
  firestore() {
    return {
      calEvent: db.collection("calEvent"),
      users: db.collection("users"),
    };
  },
  created() {
    this.$firestore.calEvent.get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        const bookedSlots = doc
          .data()
          .slots.filter((slot) => slot.booked === true);
        if (bookedSlots && bookedSlots.length > 0) {
          const slotsPerDay = {
            date: doc.data().date,
            slots: bookedSlots,
          };
          this.bookedDays.push(slotsPerDay);
        }
      });
      // put most recent booking at top of the list
      this.bookedDays = this.bookedDays.reverse();
    });
  },
  methods: {
    isTodayOrFuture(day) {
      const today = moment();
      const someday = moment(day.date);
      return someday.isSame(today, "day") || someday.isAfter(today);
    },
    addAdmin(e) {
      e.preventDefault();
      this.message = "";
      const addAdmin = functions.httpsCallable("addAdmin");
      addAdmin({ email: this.adminEmail })
        .then((result) => {
          this.message = result.data.message;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.appointmentsRoot {
  overflow-y: auto;
  max-height: 500px;
}
</style>
